import { SchemaService } from "@/shared/services/SchemaService";
import { CalculationSchema } from "../models/CalculationSchema";
import { CalculationsService } from "./CalculationsService";




export class CalculationSchemaService extends SchemaService<CalculationSchema> {

    static readonly injectableKey = 'CalculationSchemaService';

    get injectableKey() {
        return (this.constructor as typeof CalculationSchemaService).injectableKey;
    }

    public cdnContentPath: string = "custom_calculations/calculations_schemas";

    public getInternalSchemas(): Array<CalculationSchema> {

        const internalCalculationSchemas = [
            {
                "type": `${CalculationsService.CUSTOM_CALCULATION_TYPE}`,
                "display_name": "Unknown Calculation",
                "description": "Add unknown Calculation",
                "category": "Custom",
                "is_visible": false,
                "fields": [
                    {
                        "name": "value",
                        "display_name": "Json",
                        "field_type": "json",
                        "required": true,
                        "description": "Json Value"
                    }
                ],
                "examples": [
                    {
                        "type": "json"
                    }
                ]
            },
        ] as Array<CalculationSchema>;

        return internalCalculationSchemas;

    }

}